// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BwqAFNe6GQ_NKTgP{margin:0 auto;max-width:656px}.BwqAFNe6GQ_NKTgP .w_S1avZCWO0JdNJS{display:flex;max-width:656px;text-align:center;align-items:center;justify-content:center;overflow-wrap:break-word}.BwqAFNe6GQ_NKTgP .w_S1avZCWO0JdNJS.AYZmL7em4Xcphg_d{max-width:368px;margin:0 auto}.BwqAFNe6GQ_NKTgP .w_S1avZCWO0JdNJS .NjFAbOw5gT4qRrd5{padding-left:2px;margin-top:-8px;font-size:9px;color:var(--py-primary-9);opacity:.7}.BwqAFNe6GQ_NKTgP .w_S1avZCWO0JdNJS .NjFAbOw5gT4qRrd5:hover{opacity:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `BwqAFNe6GQ_NKTgP`,
	"title": `w_S1avZCWO0JdNJS`,
	"cohortTitle": `AYZmL7em4Xcphg_d`,
	"infoIcon": `NjFAbOw5gT4qRrd5`
};
export default ___CSS_LOADER_EXPORT___;
